import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "bootstrap/dist/css/bootstrap.min.css"
 import "bootstrap"
import '../src/assets/styles.css'
import '../src/assets/mediaquerry.css'
import VueGtag from "vue-gtag";

createApp(App)
    .use(router)
    .use(VueGtag, {
        config: { id: "G-38FZWV7VTH" }
    })
    .mount('#app')

//createApp(App).mount('#app')


